import { TTagRemoveData } from 'tag/ts/smart_tag/types/api/TTagRemoveData';
import { TTagResetData } from 'tag/ts/smart_tag/types/api/TTagResetData';
import { ITag } from 'tag/ts/tag/interfaces/ITag';
import { SmartTagRemovalOperations } from './SmartTagRemovalOperations';
import { SmartTagResetOperations } from './SmartTagResetOperations';
import { ISmartTagOperationsDependencies } from './types/SmartTagOperationsTypes';

/**
 * @copyright © Paramount Streaming
 * @author  Stan Gletski
 * @description Coordinator for tag operations using specialized operation classes
 *
 * This coordinator delegates tag operations to specialized classes to reduce cognitive
 * complexity while maintaining a clean public API. Uses composition pattern to separate
 * single-tag removal from batch reset operations for improved maintainability.
 */
export class SmartTagTagOperations {
	#removalOps: SmartTagRemovalOperations;
	#resetOps: SmartTagResetOperations;

	constructor( deps: ISmartTagOperationsDependencies ) {
		this.#removalOps = new SmartTagRemovalOperations( deps );
		this.#resetOps = new SmartTagResetOperations( deps );
	}

	removeTag = ( tag: ITag ): Promise<TTagRemoveData> => this.#removalOps.removeTag( tag );
	resetTags = (): Promise<TTagResetData> => this.#resetOps.resetTags();
}